import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import AboutBreadcrumb from "../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";
import corePrinciplesData from "../components/AboutPage/CorePrinciples/corePrinciplesData";
import "./PrincipleDetailsPage.css";

const PrincipleDetailsPage = () => {
  const { slug } = useParams();

  const principle = corePrinciplesData.find(
    (item) => item.slug === slug
  );

  if (!principle) {
    return <h2 style={{ padding: "100px", textAlign: "center" }}>Not Found</h2>;
  }

  return (
    <>
      <Header />
      <AboutBreadcrumb label={principle.title} />

      <section className="principle-details">
        <div className="principle-container">
          <img src={principle.image} alt={principle.title} />
          <h1>{principle.title}</h1>
          <p>{principle.fullDescription}</p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrincipleDetailsPage;
